<template>  
    <div v-if="replyDetails.replydialog || showpost">
    <!--  -->
    <v-overlay opacity="0.8">
        <div class="reply-con">
            <h3 v-if="showpost===true" class="header-text --green"> 
                <v-icon @click="backtopost" class="icon" color="#1F8F58" size="25">mdi-arrow-left</v-icon>  
                Comments
            </h3>
            <h3 v-else class="header-text --green">Reply</h3>
 
            <div class="loader" v-if="loading">
                <v-progress-circular
                    :size="80"
                    :width="5"
                    color="#6FB793"
                    indeterminate
                ></v-progress-circular>
            </div> 
            <div style="height:490px" v-else>
            <div class="comment_con">
            <v-row 
                style="overflox-y: auto" 
                class="mt-3 scrollbar" 
                v-for="(comment, index) in commentsList" 
                :key="index"
            >
                <v-col cols="1">
                    <v-list-item-avatar tile>
                        <img :src="comment.user.image ? comment.user.image.small : dummyAvatar"/>
                    </v-list-item-avatar>
                </v-col>

                <v-col cols="11">
                    <div class="comment-by">
                        <span class="name">{{ comment.user.full_name }}</span>
                        <span class="comment-date" style="float: right">
                            <time-ago :datetime="comment.modified_at" long></time-ago>
                        </span>
                        <span style="clear: both"> &nbsp; </span>

                        <div class="comment-txt">
                            <p>{{ comment.comment_text }}</p>
                        </div>

                        <div
                            class="reply pointer --green"
                            @click="comment.liked_by_user = !comment.liked_by_user"
                        >
                            <span v-if="comment.nested_comment.length > 0">{{
                                comment.nested_comment.length
                            }}</span>
                            Reply
                        </div>

                    <!--Nested Comments Session Start-->
                    <div v-if="comment.liked_by_user">
                        <v-row
                            class="mt-1"
                            v-for="(item, index2) in comment.nested_comment"
                            :key="index2"
                        >
                            <v-col cols="1">
                                <v-list-item-avatar tile>
                                    <img
                                        :src="
                                            item.user.image
                                                ? item.user.image.small
                                                : dummyAvatar
                                        "
                                    />
                                </v-list-item-avatar>
                            </v-col>
                            <v-col cols="11">
                                <div class="comment-by">
                                    <span class="name">{{
                                        item.user.full_name
                                    }}</span>
                                    <span
                                        class="comment-date"
                                        style="float: right"
                                    >
                                        <time-ago
                                            :datetime="item.modified_at"
                                            long
                                        ></time-ago>
                                    </span>
                                    <span style="clear: both"> &nbsp; </span>
                                    <div class="comment-txt">
                                        {{ item.comment_text }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="pt-2">
                            <v-col>
                                <v-text-field
                                    filled
                                    light
                                    outlined
                                    style ="max-width : 99%"
                                    v-model="newNestedComment"
                                    placeholder="Add a comment here.."
                                    @click:append="addNestedComment(comment.id)"
                                    background-color="#F6F9F6"
                                    @keyup.enter="addNestedComment(comment.id)"
                                    append-icon="mdi-send"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <!--Nested Comments Session End-->      

                    </div>
                </v-col>
            </v-row>
            </div>
            <v-row 
                class="pt-3 comment_box"
                style="position: sticky; bottom: 0; background-color: white"         
            >
                <v-col cols="12">
                    <v-text-field
                        filled light 
                        outlined 
                        placeholder="Add a comment..."
                        v-model="newCommentText"
                        background-color="#F6F9F6"
                        append-icon="mdi-send"
                        @click:append="addNewComment"
                        @keyup.enter="addNewComment"
                    ></v-text-field>
                </v-col>
            </v-row>
            </div>


        </div>
        <div v-if="showpost===true" class="closebtn-con">
            <button
                class="closeBtn"
                @click="closecommentpage"
            >
                Close
            </button>
        </div>
        <div v-else class="closebtn-con">
            <button
                class="closeBtn"
                @click="hidereply"
            >
                Close
            </button>
        </div>
    </v-overlay>
    </div>
</template>
<!-- @click="(hidereply)(showpost = false)" -->

<script>
import API_URL from "../../../../helpers/apiUrls";
import { mapActions } from "vuex";
import { TimeAgo } from "vue2-timeago";
import { stringify } from "querystring";
import accessToken from "../../../../helpers/accessToken";

export default {
    name: "showcomments",
    components: { TimeAgo },
    data() {
        return {
            loading: true,
            comments_replys_flag: false,
            commentsId: "", 
            commentTest: "",
            nextedCommentTest: "",
            dummyAvatar: require("../../../../assets/DummyAvatar.png"),
            showcommentpage : true,
            showthispage: true,
            commentsList : [],
            newCommentText : "",
            newNestedComment : "",
        };
    },
    computed: {
       	replyDetails() {
        	return this.$store.getters["queryStore/GET_REPLY_DETAILS"];
        },
    },
    mounted(){
        this.getCommentList();
    },
    methods:{
        ...mapActions(["queryStore", 'toggledreplyialog']),

        // add a nested comment
        addNestedComment(postid){
            this.loading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("RESPONSE", response);

                    this.getCommentList();
                    this.newNestedComment = "";
                    this.loading = false;
                }
            };
            const errorHandler = (error) => {
                this.loading = false;
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
            };

            const data = {
                feed_type : "post_feed",
                comment: this.newNestedComment,
                post_id: this.id,
                id : postid,
                comment_author_type: "business",
                business_id: `${localStorage.getItem("Brand-ID")}`,
            };
            console.log("NEW NESTED COMMENT DATA --> ", data);

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestPOST(
                API_URL.createContent__nestedComment,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },

        // add a new comment in thread
        addNewComment(){
            this.loading = true;
            const successHandler = (response) => {
                // this.loading = false;
                if (response.status === 200) {
                    console.log("RESPONSE", response);
                    this.getCommentList();
                    this.commentTest = "";
                    this.loading = false;
                }
            };
            const errorHandler = (error) => {
                this.loading = false;
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
            };

            const data = {
                feed_type : "post_feed",
                comment: this.newCommentText,
                post_id: this.id,
                comment_author_type: "business",
                business_id: `${localStorage.getItem("Brand-ID")}`,
            };
            console.log("NEW COMMENT DATA --> ", data);

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestPOST(
                API_URL.createContent__comment,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },

        // get already present comment list
        getCommentList() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.loading = false
                    console.log(response);
                    this.commentsList = response.data.results;
                }
            };

            const errorHandler = (error) => {
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
                this.loading = false
            };
            const data = {
                id : this.id,
                feed_type : "post_feed",
                page: "1",
                business_id: `${localStorage.getItem("Brand-ID")}`
            }
            this.requestGET(
                API_URL.createContent__comment,
                data,
                {},
                successHandler,
                errorHandler
            );
        },
        hidereply(){
            this.toggledreplyialog()
        },
        closecommentpage(){
            this.$emit('closecommentpage');
        },
        backtopost(){
            this.$emit('closecomment');
        }
    },
    props: {
        showpost: Boolean,
        id : stringify,
    },
}
</script>


<style lang="scss" scoped>
.reply-con{
    // max-width: 500px;
    width: 600px;
    background-color: #FFFFFF;
    padding: 25px;
    border-radius: 8px;
    height: 550px;
    // overflow: hidden;

    // display: flex;
    // flex-direction: column;
}
.loader{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.header-text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;

    .icon{
        background-color: #EFF6F3;
        padding: 8px;
        border-radius: 3px;
    }
}
.comment_con{
    height: 390px;
    // width: 100%;
    overflow-y: auto;
    overflow-x: none;
}
.comment-by {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #445149;
}
.name {
    padding-left: 12px;
    float: left;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
}
.comment-date {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #445149;
    text-align: right;
    padding-right: 10px;

    font-family: "Roboto";
    font-style: normal;
}
.comment_box{
    position: sticky;
    bottom: 0%;
    // align-self: flex-end

    .col-12{
        padding-bottom: 0px;
        padding-top: 0px;
    }
}

.comment-txt {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 18px;
    color: #445149;
    text-align: justify;
    padding: 10px 12px;
}
.reply {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 0px;
    text-align: left;
    padding: 10px 12px;
}
.comment-con{
    position: relative;
    top: 100px;
}
.closebtn-con{
    width: 100%;
    text-align: center;
}
.closeBtn {
  background-color: #ffffff;
  width: 185px;
  margin: 20px auto 0px;
  height: 55px;
  border-radius: 33px;
  color: #9e9f9e;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
}
.col .col-1 .col-11{
    padding: 0px;
}
.row{
    margin: 0px;
}
.scrollbar{
::-webkit-scrollbar {
  width: 15px;
  margin: 3px;
  border-left: 1px solid rgba(50, 52, 65, 0.1);
  border-right: 1px solid rgba(50, 52, 65, 0.1);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(50, 52, 65, 0.15);
  border: 4px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-track {
  width: 15px;
}
::-webkit-scrollbar-corner {
  display: none;
  height: 0px;
  width: 0px;
}
}
</style>
